import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../services/auth.store';
import { LoggerService } from '../../logging/logger.service';

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authStore = inject(AuthStore);
    const logger = inject(LoggerService);

    // If the user is authenticated, allow access to the route. Otherwise, redirect to the public page.
    if (authStore.isAuthenticated()) {
        logger.debug('AuthGuard', 'Access granted to protected route', { route: route.routeConfig?.path });
        return true;
    } else {
        logger.warn('AuthGuard', 'Access denied to protected route - user not authenticated', { route: route.routeConfig?.path });
        return router.createUrlTree(['/public']);
    }
};


